import {
  Account,
  AmountCellTwo,
  CompanyWithInitialsCell,
  DateCellTwo,
  Rereference,
  StatusCell,
} from "@/app/components/common/table/KendoCustomCells";
import KendoTable, {
  type ColumnConfig,
} from "@/app/components/common/table/KendoTable";
import { type FC } from "react";
import type { RecentTransactionsResponse } from "@/app/types/payments";
import type {
  GridCellProps,
  GridRowClickEvent,
} from "@progress/kendo-react-grid";
import { useT } from "@/app/hooks/useT";

interface RepairTransactionTableProp {
  transactions: RecentTransactionsResponse[];
  handleRowClick?: (event: GridRowClickEvent) => void;
}

const CompanyCell = (props: GridCellProps) => (
  <CompanyWithInitialsCell {...props} />
);

const AccountCell = (props: GridCellProps) => <Account {...props} />;

const ReferenceCell = (props: GridCellProps) => <Rereference {...props} />;

const PaymentDateCell = (props: GridCellProps) => <DateCellTwo {...props} />;

const AmountCell = (props: GridCellProps) => <AmountCellTwo {...props} />;

// const StatusPaymentCell = (props: GridCellProps) => (
//   <StatusCell module="payments" {...props} />
// );

const moduleMap = {
  TRANSACTIONS: "payments", // was PAYMENT
  RTP: "rtp",
  BENEFICIARY: "beneficiary",
  BULK_PAYMENT: "bulk", // was BULK
  PAYROLL: "bulk",
} as const;

const StatusPaymentCell = (props: GridCellProps) => {
  const module =
    moduleMap[props.dataItem.moduleType as keyof typeof moduleMap] ?? "text";

  return (
    <StatusCell {...props} module={module} statusField="paymentStatusCode" />
  );
};

const RepairTransactionTable: FC<RepairTransactionTableProp> = ({
  transactions,
  handleRowClick,
}) => {
  const t = useT();
  const columns: ColumnConfig[] = [
    {
      field: "companyName",
      title: t("beneficiary"),
      cell: CompanyCell,
      width: "20%",
    },
    {
      field: "debitAccount",
      title: t("account"),
      cell: AccountCell,
      // width: "20%",
    },

    {
      field: "gxChnNo",
      title: t("growx_reference"),
      cell: ReferenceCell,
    },
    {
      field: "paymentDate",
      title: t("payment_date"),
      cell: PaymentDateCell,
      //   width: "20%",
    },
    {
      field: "debitAmount",
      title: t("amount"),
      cell: AmountCell,
      // width: "17%",
      headerClassName: "amount-header-center",
    },

    {
      field: "status",
      title: t("status"),
      cell: StatusPaymentCell,
      // width: "13%",
    },
  ];

  return (
    <div className="mt-3">
      <div className="K-table-transaction">
        <KendoTable
          data={transactions}
          columns={columns}
          onRowClick={handleRowClick}
          className="kendo-grid-transactions"
          showHeader={transactions?.length > 0}
        />
      </div>
    </div>
  );
};

export default RepairTransactionTable;
